import { useIntl } from 'react-intl'
import { NotificationUnreadMessages } from '../../../../../atoms/icons/menu/index.js'
import colorsOptions from '../../../../../fundamentals/colors-styles/constants.js'
import NotFoundComponent from '../../../../../molecules/not-found/index.jsx'
import NotificationListItem from './notification-list-item.jsx'
import { AsyncLoaderComponent } from '../../../../../../async-loader/async-loader-component.jsx'

const NotificationList = ({
  notificationData = [],
  isLoading,
  onClickNotification
}) => {
  const { formatMessage } = useIntl()

  const NoNotificationsYet = () => (
    <div
      style={{
        padding: '10rem 0'
      }}
    >
      <NotFoundComponent
        header={formatMessage({ id: 'no_notifications_yet' })}
        description={formatMessage({ id: 'new_updated_will_appear_here' })}
        icon={
          <NotificationUnreadMessages
            stroke={colorsOptions.greys['grey-50']}
            specialFill={colorsOptions.greys['grey-20']}
            specialStroke={colorsOptions.greys['grey-20']}
            style={{
              width: '120px',
              height: '120px'
            }}
          />
        }
      />
    </div>
  )

  if (isLoading) {
    return (
      <div
        style={{
          padding: '10rem 0'
        }}
      >
        <AsyncLoaderComponent />
      </div>
    )
  }

  if (!notificationData.length) return NoNotificationsYet()

  return notificationData.map((item, index) => (
    <NotificationListItem
      key={index}
      item={item}
      index={index}
      onClickNotification={onClickNotification}
    />
  ))
}

export default NotificationList
